import React from 'react';
import { Spacer } from '@cleartrip/bento';

import { List } from 'components/travelsafe';

function ListBlock({ item }) {
	return (
		<>
			{item.title && (
				<>
					<Spacer className='pt-3' />
					<List.Title>{item.title}</List.Title>
					<Spacer className='pt-2' />
				</>
			)}
			{item.description && (
				<>
					<p
						className='fs-4 c-neutral-700 lh-copy lh-copy--xs'
						dangerouslySetInnerHTML={{
							__html: item.description,
						}}
					></p>
					<Spacer className='pt-2' />
				</>
			)}
			{item.listItems &&
				item.listItems.map(
					(listItem, idx) =>
						listItem && (
							<List.Item
								className='fs-4'
								key={idx}
								dangerouslySetInnerHTML={{
									__html: listItem,
								}}
							/>
						)
				)}

			{item.lists &&
				item.lists.map((innerListItem, idx) => (
					<>
						{innerListItem.title && (
							<>
								<List.Title>{innerListItem.title}</List.Title>
								<Spacer className='pt-2' />
							</>
						)}

						{innerListItem.description && (
							<>
								<Spacer className='pt-1' />
								<p
									className='fs-4 c-neutral-700 lh-copy lh-copy--xs'
									dangerouslySetInnerHTML={{
										__html: innerListItem.description,
									}}
								></p>
								<Spacer className='pt-2' />
							</>
						)}

						{innerListItem.listItems &&
							innerListItem.listItems.map(
								(listItem, idx) =>
									listItem && (
										<List.Item
											className='fs-4'
											key={idx}
											dangerouslySetInnerHTML={{
												__html: listItem,
											}}
										/>
									)
							)}
						{innerListItem.length - 1 !== idx && <Spacer className='pt-2' />}
					</>
				))}
		</>
	);
}

export default ListBlock;
